<template>
  <div class="wrap">
    <div class="container-fluid">
      <div
        class="protype swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events"
      >
        <div class="cplist">
          <a href="/commonp?type=13"> <p class="ellipsis">布电线</p></a>
        </div>
        <div class="cplist">
          <a href="/commonp?type=14"> <p class="ellipsis">电力电缆</p></a>
        </div>
        <!-- <div class="cplist">
              <a href="/commonp?type=15"> <p class="ellipsis">橡套电缆</p></a>
            </div> -->
        <div class="cplist">
          <a href="/commonp?type=16"> <p class="ellipsis">控制电缆</p></a>
        </div>
        <div class="cplist">
          <a href="/commonp?type=17"> <p class="ellipsis">低烟无卤电缆</p></a>
        </div>
        <div class="cplist">
          <a href="/commonp?type=18"> <p class="ellipsis">高压电缆</p></a>
        </div>
        <div class="cplist">
          <a href="/commonp?type=19"> <p class="ellipsis">护套线</p></a>
        </div>
        <div class="cplist">
          <a href="/commonp?type=20"> <p class="ellipsis">集束电缆</p></a>
        </div>
        <div class="cplist">
          <a href="/commonp?type=21"> <p class="ellipsis">架空电缆</p></a>
        </div>
        <div class="cplist">
          <a href="/commonp?type=22"> <p class="ellipsis">矿物质电缆</p></a>
        </div>
        <div class="cplist">
          <a href="/commonp?type=23"> <p class="ellipsis">铝合金电缆</p></a>
        </div>
        <div class="cplist">
          <a href="/commonp?type=24"> <p class="ellipsis">特种电缆</p></a>
        </div>
        <!-- <div class="cplist">
              <a href="/commonp?type=25"> <p class="ellipsis">通信电缆</p></a>
            </div> -->
        <div class="cplist">
          <a href="/commonp?type=26"> <p class="ellipsis">阻燃电缆</p></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
